module.exports = __webpack_public_path__ + "img/icons-microphone.7421cdc9.svg";